import { getAttr, getChild, getChildren, findAll, parseXml } from './xmlUtils';

export function parseRels(xml: string): Map<string, string> {
    const doc = parseXml(xml, 'document.xml.rels');
    const map = new Map<string, string>();
    for (const rel of findAll(doc.documentElement, 'Relationship')) {
        const type = rel.getAttribute('Type') || '';
        if (type.includes('hyperlink')) {
            const id = rel.getAttribute('Id') || '';
            const target = rel.getAttribute('Target') || '';
            if (id && target) map.set(id, target);
        }
    }
    return map;
}

export function parseStyles(xml: string): Map<string, number> {
    const doc = parseXml(xml, 'styles.xml');
    const headingMap = new Map<string, number>();

    for (const style of findAll(doc.documentElement, 'style')) {
        const styleId = getAttr(style, 'styleId');
        if (!styleId) continue;

        const nameEl = getChild(style, 'name');
        const name = nameEl ? getAttr(nameEl, 'val').toLowerCase() : '';
        const nameMatch = name.match(/^heading\s*(\d)$/);
        if (nameMatch) {
            headingMap.set(styleId, parseInt(nameMatch[1]));
            continue;
        }

        const idMatch = styleId.match(/^[Hh]eading(\d)$/);
        if (idMatch) {
            headingMap.set(styleId, parseInt(idMatch[1]));
        }
    }

    return headingMap;
}

export function parseNumbering(
    xml: string
): Map<string, Map<number, string>> {
    const doc = parseXml(xml, 'numbering.xml');
    const result = new Map<string, Map<number, string>>();
    const abstractMap = new Map<string, Map<number, string>>();

    for (const an of findAll(doc.documentElement, 'abstractNum')) {
        const id = getAttr(an, 'abstractNumId');
        const levels = new Map<number, string>();
        for (const lvl of getChildren(an, 'lvl')) {
            const ilvl = parseInt(getAttr(lvl, 'ilvl') || '0');
            const numFmt = getChild(lvl, 'numFmt');
            const format = numFmt
                ? getAttr(numFmt, 'val') || 'decimal'
                : 'decimal';
            levels.set(ilvl, format);
        }
        if (id) abstractMap.set(id, levels);
    }

    for (const num of findAll(doc.documentElement, 'num')) {
        const numId = getAttr(num, 'numId');
        const ref = getChild(num, 'abstractNumId');
        const refVal = ref ? getAttr(ref, 'val') : '';
        if (numId && abstractMap.has(refVal)) {
            result.set(numId, abstractMap.get(refVal)!);
        }
    }

    return result;
}
